import {get, cloneDeep} from 'lodash-es'
/**
 * 更新商圈列表信息
 * @param state
 * @param payload
 */
export function updateAreaList (state, payload) {
  state.areaList = get(payload, 'clusterList', [])
}

/**
 * 更新店铺列表信息
 * @param state
 * @param payload
 */
export function updateShopList (state, payload) {
  state.shopList = get(payload, 'shopList', [])
}

/**
 * 更新地图展示的店铺列表
 * @param {*} state
 * @param {*} payload
 */
export function updateMapShopList (state, payload = {}) {
  state.mapShopList = payload.list || []
}

export function updateSelectValues (state, payload) {
  state.selectValues = cloneDeep(payload)
  console.log(payload, '更新了筛选项', state.selectValues)
}

export function updateShopId (state, payload) {
  state.bizoppId = payload
  console.log(payload, '点击了店铺', state.bizoppId)
}

export function updateCurrentlyGeo (state, payload) {
  state.currentlyGeo = cloneDeep(payload)
  console.log(payload, '更新了经纬度', state.currentlyGeo)
}
